<template>
  <div class="container">
    <div class="mt-4">
      <div class="col-12 mt-2 cust">
        <div class="row">
          <div class="col-sm-12 h3">Add User</div>
        </div>
        <div class="row shadow py-3 report">
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Email Address *</label>
            <br />
            <input
              class="form-control"
              type="email"
              v-model="email"
              placeholder="Email"
              @keyup="validateEmail(email)"
            />
          </div>
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Name *</label>
            <br />
            <input class="form-control" type="email" v-model="name" placeholder="Name" />
          </div>
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Password (minimum 8 characters)*</label>
            <br />
            <input
              class="form-control"
              type="password"
              v-model="password"
              @keyup="pwdLenth"
              placeholder="Password"
            />
          </div>
          <div class="col-md-6 col-sm-12 px-3 py-2 mt-auto"></div>
          <div class="col-md-6 col-sm-12 px-3 py-2">
            <label class="labelClass">Select Company *</label>
            <br />
            <select class="form-control inputFont" v-model="customer">
              <option disabled selected value>Please Select</option>
              <option v-for="(customer, key) in companies" :key="key">{{customer.name}}</option>
            </select>
          </div>
          <div
            class="col-md-6 col-sm-12 mt-auto text-right px-3 py-2 d-flex justify-content-around"
          >
            <label>
              <input type="checkbox" v-model="admin" />
              <span class="ml-3">Admin</span>
            </label>
            <button @click="submitForm" class="btn btn-danger">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "underscore";
import { apiCall } from "@/utils/api";
import swtAlrt from "../../../mixins/swtalrt";

/* eslint-disable */
export default {
  data() {
    return {
      admin: false,
      email: "",
      emailValid: "",
      password: "",
      pwd: 0,
      name: "",
      customer: "",
      companies: {},
      companyId: "",
      addComp: 3,
    };
  },
  mixins: [swtAlrt],
  watch: {
    customer(newVal) {
      let company = _.filter(this.companies, (company) => {
        return company.name == newVal;
      });
      this.companyId = company[0]._id;
    },
  },
  mounted() {
    this.getAllCustomer();
  },
  computed: {},
  methods: {
    submitForm() {
      if (this.emailValid && this.pwd && this.companyId && this.name) {
        let body = {
          user: {
            name: this.name,
            password: this.password,
            email: this.email,
            isAdmin: this.admin,
            companyId: this.companyId,
          },
        };
        apiCall({ url: "user/add", data: body, method: "post" })
          .then((resp) => {
            this.swalSuccess();
          })
          .catch((err) => {
            this.swalNetworkError();
          });
      } else {
        if (this.pwd && this.emailValid) {
          this.swalError();
        } else if (!this.emailValid) {
          this.swalEmailError();
        } else if (!this.pwd) {
          this.swalPwdError();
        }
      }
    },
    getAllCustomer() {
      apiCall({ url: "company", method: "get" })
        .then((resp) => {
          this.companies = resp.data;
        })
        .catch((err) => {
          //   console.log(err);
        });
    },
    resetIm() {
      this.addComp = 3;
    },
  },
};
</script>

<style scoped>
</style>
